// extracted by mini-css-extract-plugin
export default {"root":"AccordionItemHeader_root__lR+-o","placeHolderShimmer":"AccordionItemHeader_placeHolderShimmer__Kdnh0"};